import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { externalLoanCardSx } from './externalLoanCardStyles';

export const externalLoanWorkflowStages = [
  { key: 'submitted', label: 'Application Submitted', actor: 'Member', status: 'completed' },
  { key: 'review', label: 'System Eligibility Review', actor: 'Savvyy Community', status: 'completed' },
  { key: 'contract', label: 'Digital Contract Generated', actor: 'System', status: 'completed' },
  { key: 'chairperson', label: 'Chairperson Approval', actor: 'Chairperson', status: 'pending' },
  { key: 'secretary', label: 'Secretary Approval', actor: 'Secretary', status: 'pending' },
  { key: 'accountant', label: 'Accountant Approval', actor: 'Accountant', status: 'pending' },
  { key: 'bellicks', label: 'Submitted to Bellicks', actor: 'System', status: 'pending' },
  { key: 'gm', label: 'GM Review', actor: 'Bellicks GM', status: 'pending' },
  { key: 'approved', label: 'Approved', actor: 'Bellicks', status: 'pending' },
  { key: 'disbursed', label: 'Disbursed', actor: 'Finance', status: 'pending' },
  { key: 'repayment', label: 'Repayment', actor: 'Member', status: 'pending' },
  { key: 'completed', label: 'Completed', actor: 'System', status: 'pending' },
];

const statusColor = (status) => {
  switch (status) {
    case 'completed':
      return 'success';
    case 'current':
      return 'primary';
    case 'rejected':
      return 'error';
    default:
      return 'default';
  }
};

const WorkflowTimeline = ({ currentPhase }) => {
  const activeIndex = externalLoanWorkflowStages.findIndex((stage) => stage.key === currentPhase) + 1;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        ...externalLoanCardSx,
      }}
    >
      <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>Application Workflow Timeline</Typography>
      <Stack spacing={2}>
        {externalLoanWorkflowStages.map((stage, index) => {
          const isCompleted = index + 1 < activeIndex;
          const isCurrent = index + 1 === activeIndex;
          return (
            <Box key={stage.key} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <Box sx={{ mt: 0.5, width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: isCompleted ? 'success.main' : isCurrent ? 'primary.main' : 'grey.200', color: 'common.white', fontWeight: 700 }}>
                {index + 1}
              </Box>
              <Box sx={{ flex: 1, py: 0.5 }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }}>
                  <Typography fontWeight={700}>{stage.label}</Typography>
                  <Chip label={isCompleted ? 'Completed' : isCurrent ? 'Current' : 'Pending'} size="small" color={statusColor(isCompleted ? 'completed' : isCurrent ? 'current' : 'pending')} />
                </Stack>
                <Typography variant="body2" color="text.secondary">Actor: {stage.actor}</Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default WorkflowTimeline;
